/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Decks_Deck_CountInputs */



/**
* | output |
* | --- |
* | "{count} deck(s)" |
*
* @param {Decks_Deck_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_deck_count = /** @type {((inputs: Decks_Deck_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Deck_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} deck(s)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} deck(s)`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} deck(s)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} deck`)
	return /** @type {LocalizedString} */ (`${i?.count} deck(s)`)
});